import { Grid, Typography } from "@mui/material";
import PerformanceDashboardBottomRatedPages from "./PerformanceDashboardBottomRatedPages";
import PerformanceDashboardTopRatedPages from "./PerformanceDashboardTopRatedPages";
import "../PerformanceDashboard.css";
import { useSelector } from "react-redux";

const PerformanceDashboardRatedTable = () => {
  const { exequteQueryContentQuery2 } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  return (
    <>
      <Grid container spacing={3} mb={2} className="ratedTableWrap">
        <Grid item xs={6}>
          <Typography sx={{ fontSize: "18px", color: "#000000" }}>
            Top Rated Pages
          </Typography>
          <PerformanceDashboardTopRatedPages
            rows={exequteQueryContentQuery2?.payload}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography sx={{ fontSize: "18px", color: "#000000" }}>
            Bottom Rated Pages
          </Typography>
          <PerformanceDashboardBottomRatedPages
            rows={exequteQueryContentQuery2?.payload}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PerformanceDashboardRatedTable;
